export function searchSuggestion({ Label, Tag, Url }, index) {
  return `
    <li
      aria-selected="false"
      aria-labelledby="search-suggested-results-heading"
      class="header__search-item"
      role="option"
      id="suggestion-${index}"
    >
      <a href="${Url}" tabindex="0">
        ${Label ? `<span>${Label}</span>` : ''}
        ${Tag ? `<span>${Tag}</span>` : ''}
      </a>
    </li>
  `;
}

export function searchSuggestionDidYouMean(Label, Value, Url, index) {
  return `
      <li
      aria-labelledby="search-suggested-results-heading"
      class="header__search-item--did-you-mean"
      role="option"
      id="suggestion-${index}"
    >
      <a href="${Url}" tabindex="0">
        ${Label ? `<span>${Label} ${Value}</span>` : ''}
      </a>
    </li>
  `;
}
